'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementSelector = require('../elementSelector');

var _elementSelector2 = _interopRequireDefault(_elementSelector);

var _Element = require('../Element');

var _Element2 = _interopRequireDefault(_Element);

require('./ElementDragPreview.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Returns the display element that matches the type of the element specified.
 * This allows the React component appropriate to the element type to be used, instead of a generic element
 * that needs to know every different type of element and how to render it.
 *
 * @param element The element object that will be rendered by this component.
 * @constructor Element
 */

var ElementDragPreview = (_dec = (0, _reactRedux.connect)(_elementSelector2.default), _dec(_class = function (_React$Component) {
    _inherits(ElementDragPreview, _React$Component);

    function ElementDragPreview() {
        _classCallCheck(this, ElementDragPreview);

        return _possibleConstructorReturn(this, (ElementDragPreview.__proto__ || Object.getPrototypeOf(ElementDragPreview)).apply(this, arguments));
    }

    _createClass(ElementDragPreview, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ElementDragPreview' },
                _react2.default.createElement(_Element2.default, _extends({}, this.props, { isDragging: false }))
            );
        }
    }]);

    return ElementDragPreview;
}(_react2.default.Component)) || _class);


ElementDragPreview.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    element: _propTypes2.default.object,
    className: _propTypes2.default.string,
    dragOrigin: _propTypes2.default.object
};

exports.default = ElementDragPreview;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/ElementDragPreview.js
// module id = 1968
// module chunks = 0